import type { ParsedUrlQuery } from 'querystring';
import type { Locale } from '@flex-packages/i18n';
import { decideLocale } from '@flex-packages/i18n';
import {
  generateFlexUTMs,
  type UserProperty as AmplitudeUserProperty,
} from '@flex-packages/logger';
import type { AppContext, AppInitialProps } from 'next/app';
import App from 'next/app';

export interface InitialProps extends AppInitialProps {
  serverSideProps: {
    locale: Locale;
    now: number;
    userAgent: string;
    amplitudeUserProperties: AmplitudeUserProperty;
    flexUTMs: ParsedUrlQuery;
  };
}

export async function getInitialProps(
  appContext: AppContext
): Promise<InitialProps> {
  const appProps = await App.getInitialProps(appContext);

  const { req } = appContext.ctx;

  const userAgent = req?.headers['user-agent'] || '';

  const locale = await decideLocale(appContext.ctx);

  const query = appContext.router.query;
  const flexUTMs = generateFlexUTMs(query);

  return {
    ...appProps,
    serverSideProps: {
      locale,
      now: Date.now(),
      userAgent,
      amplitudeUserProperties: {
        ...flexUTMs,
      },
      flexUTMs,
    },
  };
}
